import { FC, useEffect, useState } from "react";
import styles from "./AgeVerificationPopup.module.scss";
import bord from "../../../images/Border.svg";
import { Button, ThemeButton } from "../Button/Button";

export const AgeVerificationPopup: FC = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const hasVerifiedAge = localStorage.getItem("ageVerified");
    if (!hasVerifiedAge) {
      setShowPopup(true);
    }
  }, []);

  const handleAgeVerification = (isAdult: boolean) => {
    if (isAdult) {
      localStorage.setItem("ageVerified", "true");
      setShowPopup(false);
    } else {
      window.location.href = "https://www.google.com";
    }
  };

  if (!showPopup) return null;
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <img src={bord} alt="Icon" />
        <h4 className={styles.popup_title}>Altersüberprüfung</h4>
        <p className={styles.popup_text}>
          Diese Website umfasst Material mit Altersbegrenzung, einschließlich
          Nacktbilder und expliziter Darstellung sexueller Handlungen. Indem Sie
          diese Website nutzen, bestätigen Sie, dass Sie mindestens 18 Jahre alt
          sind bzw. das Volljährigkeitsalter erreicht haben, das im Bereich der
          Gerichtsbarkeit gilt, von der Sie auf diese Website zugreifen, und
          dass Sie der Ansicht explizit sexueller Inhalte zustimmen.
        </p>
        <div className={styles.blockButton}>
          <Button onClick={() => handleAgeVerification(true)}>
            Ich bin 18 oder älter - Eingabe
          </Button>
          <Button
            theme={ThemeButton.EXIT}
            onClick={() => handleAgeVerification(false)}
          >
            I am under 18 - Exit
          </Button>
        </div>
      </div>
    </div>
  );
};
